import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from '@ynet-core/helpers';
import { NgSelectConfig } from '@ng-select/ng-select';
import { Store, select } from '@ngrx/store';
import * as Sentry from '@sentry/angular-ivy';
import * as fromRoot from './app.reducer';
import { IUserProfileModel } from './shared/models/userProfile.model';
import { environment } from '../environments/environment';



@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    globalBodyClass = 'm-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';

    constructor(
        private _router: Router,
        private config: NgSelectConfig,
        private store$: Store<fromRoot.State>,
    ) {
        // Optional configuration
        this.config.notFoundText = 'No record was found';
    }

    ngOnInit() {
        this._router.events.subscribe((route) => {
            if (route instanceof NavigationStart) {
                Helpers.setLoading(true);
                Helpers.bodyClass(this.globalBodyClass);
            }

            if (route instanceof NavigationEnd) {
                Helpers.setLoading(false);
            }
        });

        // Identify the user in Sentry so issues show who hit them. Clears on
        // logout (profile -> null). No-op when DSN is not configured (local dev).
        if (environment.sentry?.dsn) {
            this.store$.pipe(select(fromRoot.getUserInfo)).subscribe((profile: IUserProfileModel | null) => {
                if (profile?.profile) {
                    Sentry.setUser({
                        id: profile.profile.login,
                        email: profile.profile.email,
                        username: profile.profile.login,
                    });
                } else {
                    Sentry.setUser(null);
                }
            });
        }
    }
}
